import z from 'zod';

export type MenuPlannerTrackingDto = {
	parentMenuPlannerId: string;
	childMenuPlannerId: string;
	tagId: string;
	group: string;
	location: string;
	isClosed: boolean;
	remarks: { [key: string]: string } | null;
	createdBy: string | null;
	createdDateUtc: string;
	updatedBy: string | null;
	updatedDateUtc: string | null;
};

export const MenuPlannerTrackingDtoSchema: z.ZodType<MenuPlannerTrackingDto> = z.object({
	parentMenuPlannerId: z.string(),
	childMenuPlannerId: z.string(),
	tagId: z.string(),
	group: z.string(),
	location: z.string(),
	isClosed: z.boolean(),
	remarks: z.record(z.string()).nullable(),
	createdBy: z.string().nullable(),
	createdDateUtc: z.string(),
	updatedBy: z.string().nullable(),
	updatedDateUtc: z.string().nullable(),
});
